var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-child",class:{
    'slider-child--fullscreen': _vm.fullscreen,
  },style:({
    backgroundColor: _vm.color,
  }),on:{"click":function($event){return _vm.$emit('onItemClick')}}},[(_vm.fullscreen)?_c('v-img',{attrs:{"src":_vm.img,"alt":""}}):[_c('div',{staticClass:"slider-child__left"},[_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"slider-child__right"},[_c('img',{attrs:{"src":_vm.img,"alt":"Slider Image"},on:{"error":_vm.imgLoadErrorHandler}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }